module.exports = __webpack_public_path__ + "static/media/green_dot.061ddcd7.png";